import { ToolbarMenuCommandType, ToolbarMenuId } from '@src/suite/common/enums/enums';
import { MenuItem } from '@src/suite/common/st-full-screen-dialog/stories-full-screen/story-full-screen/story-actions';
import { I18nKeys } from '@src/suite/common/utils/i18n.default';

export const roActions: MenuItem[] = [
    {
        type: 'menu',
        labelKey: I18nKeys.PSTRundownMenuRundown,
        id: ToolbarMenuId.RUNDOWN,
        options: [
            // {
            //     type: 'menu',
            //     labelKey: i18nKeys.PSTEditorStoryMenuNew,
            //     id: ToolbarMenuId.RUNDOWN_NEW,
            //     icon: 'Add',
            //     showIcon: true,
            //     // options: dynamically generated based on ROTemplates
            // },
            // {
            //     type: 'divider',
            //     id: ToolbarMenuId.DIVIDER,
            // },
            // {
            //     type: 'action',
            //     labelKey: i18nKeys.PSTRundownMenuDuplicate,
            //     id: ToolbarMenuId.RUNDOWN_DUPLICATE,
            //     icon: 'content_copy',
            //     showIcon: true,
            // },
            {
                type: 'menu',
                labelKey: I18nKeys.PSTRundownMenuExport,
                id: ToolbarMenuId.RUNDOWN_EXPORT,
                icon: 'import_export',
                showIcon: true,
                options: [
                    // {
                    //     type: 'action',
                    //     labelKey: i18nKeys.PSTRundownMenuExportHtml,
                    //     id: ToolbarMenuId.RUNDOWN_EXPORT_HTML,
                    //     icon: 'html',
                    //     showIcon: true,
                    // },
                    {
                        type: 'action',
                        labelKey: I18nKeys.PSTRundownMenuExportTxt,
                        id: ToolbarMenuId.RUNDOWN_EXPORT_TXT,
                        icon: 'article',
                        showIcon: true,
                    },
                ],
            },
            // {
            //     type: 'action',
            //     labelKey: i18nKeys.PSTRundownMenuShare,
            //     id: ToolbarMenuId.RUNDOWN_SHARE,
            //     icon: 'share',
            //     showIcon: true,
            // },
            // {
            //     type: 'divider',
            //     id: ToolbarMenuId.DIVIDER,
            // },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuRename,
                id: ToolbarMenuId.RUNDOWN_RENAME,
                icon: 'drive_file_rename_outline',
                showIcon: true,
            },
            {
                type: 'divider',
                id: ToolbarMenuId.DIVIDER,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProperties,
                id: ToolbarMenuId.PROPERTIES,
                icon: 'settings',
                showIcon: true,
            },
            {
                type: 'divider',
                id: ToolbarMenuId.DIVIDER,
            },
            {
                type: 'menu',
                labelKey: I18nKeys.PSTRundownMenuArchiveRO,
                id: ToolbarMenuId.ARCHIVE_RO,
                options: [
                    {
                        type: 'action',
                        labelKey: I18nKeys.PSTRundownMenuArchiveAllRows,
                        id: ToolbarMenuId.ARCHIVE_ALL_ROWS,
                        icon: 'archive',
                        showIcon: true,
                    },
                    {
                        type: 'action',
                        labelKey: I18nKeys.PSTRundownMenuArchiveAboveBlackline,
                        id: ToolbarMenuId.ARCHIVE_ABOVE_BLACKLINE,
                        icon: 'archive',
                        showIcon: true,
                    },
                ],
                icon: 'archive',
                showIcon: true,
            },
            {
                type: 'menu',
                labelKey: I18nKeys.PSTRundownMenuArchiveCopy,
                id: ToolbarMenuId.ARCHIVE_COPY,
                options: [
                    {
                        type: 'action',
                        labelKey: I18nKeys.PSTRundownMenuArchiveAllRows,
                        id: ToolbarMenuId.ARCHIVE_COPY_ALL,
                        icon: 'archive',
                        showIcon: true,
                    },
                    {
                        type: 'action',
                        labelKey: I18nKeys.PSTRundownMenuArchiveAboveBlackline,
                        id: ToolbarMenuId.ARCHIVE_COPY_ABOVE_BLACKLINE,
                        icon: 'archive',
                        showIcon: true,
                    },
                ],
                icon: 'archive',
                showIcon: true,
            },
            {
                type: 'divider',
                id: ToolbarMenuId.DIVIDER,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuDelete,
                id: ToolbarMenuId.DELETE,
                icon: 'delete',
                showIcon: true,
                isDelete: true,
            },
        ],
    },
    {
        type: 'menu',
        labelKey: I18nKeys.PSTRundownMenuView,
        id: ToolbarMenuId.VIEW,
        options: [
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewDefault,
                id: ToolbarMenuId.LAYOUT_DEFAULT,
                // icon: 'view_list',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewUser,
                id: ToolbarMenuId.LAYOUT_USER,
                // icon: 'person',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewGroup,
                id: ToolbarMenuId.LAYOUT_GROUP,
                // icon: 'group',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewSystem,
                id: ToolbarMenuId.LAYOUT_SYSTEM,
                // icon: 'settings',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewTemplate,
                id: ToolbarMenuId.LAYOUT_TEMPLATE,
                // icon: 'group',
                showIcon: true,
            },
            {
                type: 'divider',
                id: ToolbarMenuId.DIVIDER,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewMakeDefault,
                id: ToolbarMenuId.LAYOUT_MAKE_USER,
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewMakeGroup,
                id: ToolbarMenuId.LAYOUT_MAKE_GROUP,
                showIcon: true,
            },
            {
                type: 'divider',
                id: ToolbarMenuId.DIVIDER,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewChooseColumns,
                id: ToolbarMenuId.LAYOUT_CHOOSE_COLUMNS,
                icon: 'view_column',
                showIcon: true,
            },
            {
                type: 'menu',
                labelKey: I18nKeys.PSTRundownMenuViewSavedLayouts,
                id: ToolbarMenuId.LAYOUT_SAVED,
                // icon: 'save',
                showIcon: true,
                // options: dynamically generated based on stored RO layouts
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewSaveAsNew,
                id: ToolbarMenuId.LAYOUT_SAVE_NEW,
                icon: 'save',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuViewDeleteCurrent,
                id: ToolbarMenuId.LAYOUT_DELETE,
                icon: 'delete',
                showIcon: true,
            },
        ],
    },
    {
        type: 'menu',
        labelKey: I18nKeys.PSTRundownMenuTemplate,
        id: ToolbarMenuId.RUNDOWN_TEMPLATE,
        options: [
            // {
            //     type: 'menu',
            //     labelKey: i18nKeys.PSTRundownMenuTemplateChoose,
            //     id: ToolbarMenuId.TEMPLATE_CHOOSE,
            //     icon: 'grid_view',
            //     showIcon: true,
            // },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuTemplateSaveAs,
                id: ToolbarMenuId.TEMPLATE_SAVE_AS,
                icon: 'save',
                showIcon: true,
            },
        ],
    },
    {
        type: 'menu',
        labelKey: I18nKeys.PSTRundownMenuInsert,
        id: ToolbarMenuId.INSERT,
        options: [
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuInsertRowAbove,
                id: ToolbarMenuId.INSERT_ROW_ABOVE,
                fontSet: 'st-icons',
                icon: 'mat-icon-insert-row-above',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuInsertRowBelow,
                id: ToolbarMenuId.INSERT_ROW_BELOW,
                fontSet: 'st-icons',
                icon: 'mat-icon-insert-row-below',
                showIcon: true,
            },
        ],
    },
    {
        type: 'menu',
        labelKey: I18nKeys.PSTRundownMenuProduction,
        id: ToolbarMenuId.RUNDOWN_PRODUCTION,
        options: [
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionOnAir,
                id: ToolbarMenuId.PRODUCTION_ON_AIR,
                fontSet: 'st-icons',
                icon: 'mat-icon-on-air-not-active',
                commandType: ToolbarMenuCommandType.CHECKBOX,
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionFreezePageNumbers,
                id: ToolbarMenuId.PRODUCTION_FREEZE_PAGE_NUMBERS,
                fontSet: 'st-icons',
                icon: 'mat-icon-freeze-page-numbers',
                commandType: ToolbarMenuCommandType.CHECKBOX,
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionSkipUntimed,
                id: ToolbarMenuId.PRODUCTION_SKIP_UNTIMED,
                icon: 'skip_next',
                commandType: ToolbarMenuCommandType.CHECKBOX,
                showIcon: true,
            },
            /*{
                type: 'divider',
                id: ToolbarMenuId.DIVIDER,
            },
            {
                type: 'action',
                labelKey: i18nKeys.PSTRundownMenuProductionRecord,
                id: ToolbarMenuId.PRODUCTION_RECORD,
                icon: 'emergency_recording',
                showIcon: true,
            },*/
            // {
            //     type: 'action',
            //     labelKey: i18nKeys.PSTRundownMenuProductionPauseRecording,
            //     id: ToolbarMenuId.PRODUCTION_PAUSE_RECORDING,
            //     icon: 'pause',
            //     showIcon: true,
            // },
            {
                type: 'divider',
                id: ToolbarMenuId.DIVIDER,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionMOSControlActive,
                id: ToolbarMenuId.PRODUCTION_MOS_CONTROL_ACTIVE,
                commandType: ToolbarMenuCommandType.CHECKBOX,
                fontSet: 'st-icons',
                icon: 'mat-icon-mos-control-not-active',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionMOSReadyToAir,
                id: ToolbarMenuId.PRODUCTION_MOS_READY_TO_AIR,
                commandType: ToolbarMenuCommandType.CHECKBOX,
                fontSet: 'st-icons',
                icon: 'mat-icon-mos-ready-to-air-not-active',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionMOSStorySend,
                id: ToolbarMenuId.PRODUCTION_MOS_STORY_SEND,
                fontSet: 'st-icons',
                icon: 'mat-icon-mos-story-send',
                showIcon: true,
            },
            // {
            //     type: 'divider',
            //     id: ToolbarMenuId.DIVIDER,
            // },
            // {
            //     type: 'action',
            //     labelKey: i18nKeys.PSTRundownMenuProductionSendToPrompter,
            //     id: ToolbarMenuId.PRODUCTION_SEND_TO_PROMPTER,
            //     icon: 'send',
            //     showIcon: true,
            // },
            // {
            //     type: 'action',
            //     labelKey: i18nKeys.PSTRundownMenuProductionCGDeviceControl,
            //     id: ToolbarMenuId.PRODUCTION_CG_DEVICE_CONTROL,
            //     icon: 'devices',
            //     showIcon: true,
            // },
            {
                type: 'divider',
                id: ToolbarMenuId.DIVIDER,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionLockRundown,
                id: ToolbarMenuId.PRODUCTION_LOCK_RUNDOWN,
                commandType: ToolbarMenuCommandType.CHECKBOX,
                fontSet: 'st-icons',
                icon: 'mat-icon-lock-rundown',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionLockAllStories,
                id: ToolbarMenuId.PRODUCTION_LOCK_ALL_STORIES,
                commandType: ToolbarMenuCommandType.CHECKBOX,
                fontSet: 'st-icons',
                icon: 'mat-icon-lock-all-stories-not-active',
                showIcon: true,
            },
            {
                type: 'action',
                labelKey: I18nKeys.PSTRundownMenuProductionLockTimingBar,
                id: ToolbarMenuId.PRODUCTION_LOCK_TIMING_BAR,
                commandType: ToolbarMenuCommandType.CHECKBOX,
                fontSet: 'st-icons',
                icon: 'mat-icon-lock-timing-bar-not-active',
                showIcon: true,
            },
        ],
    },
];
